import { Directive, Input } from '@angular/core'
import {
  addAttachmentsComplete,
  Attachment,
  AttachmentService,
  Destroyable,
  getAttachments,
  selectAttachmentsById,
  untilDestroy,
  UploadBoxOptions,
} from '@tokeet-frontend/tv3-platform'
import { select, Store } from '@ngrx/store'
import { FormControl } from '@angular/forms'
import { AuthService } from '@tv3/services/auth.service'
import * as lodash from 'lodash'
import { startWith, switchMap } from 'rxjs/operators'

@Directive()
export abstract class AutomationAttachmentsDataBaseComponent extends Destroyable {
  @Input() maxAttachments = 1

  abstract get attachmentsCtrl(): FormControl

  attachments: Attachment[] = []

  protected constructor(
    protected store: Store<any>,
    protected authService: AuthService,
    protected attachmentService: AttachmentService
  ) {
    super()
  }

  getUploadBoxOptions(): UploadBoxOptions {
    return {
      autoUpload: true,
      resetAfterFailed: true,
      maxSize: 1024 * 1024 * 10,
      allowedFileExtensions: ['.png', '.jpg', '.jpeg', '.pdf', '.doc', '.docx', 'xlsx'],
      maxUploads: this.maxAttachments,
      token: this.authService.token,
      guide:
        $localize`You can upload ` +
        `<strong>${this.maxAttachments}</strong>` +
        $localize` file(s) at one time and file size should be less than ` +
        `<strong>10 MB</strong>.`,
    }
  }

  ngOnInit() {
    this.store.dispatch(getAttachments({ ids: this.attachmentsCtrl.value || [] }))

    this.attachmentsCtrl?.valueChanges
      .pipe(
        startWith(this.attachmentsCtrl?.value || []),
        switchMap((ids) => this.store.pipe(select(selectAttachmentsById(ids || [])))),
        untilDestroy(this)
      )
      .subscribe((attachments) => (this.attachments = attachments))
  }

  onUploadComplete(data: any[]) {
    const attachments = lodash.map(data, (d) => Attachment.deserialize(d))
    this.store.dispatch(addAttachmentsComplete({ attachments }))
    this.attachments = [...this.attachments, ...attachments]
    this.attachmentsCtrl.setValue(this.attachments.map((t) => t.id))
  }

  onDownloadAttachment(item: Attachment) {
    this.attachmentService.downloadFile(item).subscribe()
  }

  onDeleteAttachment(item: Attachment) {
    this.attachments = lodash.filter(this.attachments, (i) => i.id !== item.id)
    this.attachmentsCtrl.setValue(this.attachments.map((t) => t.id))
  }
}
